import React from "react";
import HelpMessage from "./HelpMessage";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  return (
    <div className="limiter">
      <div className="container-login100">
        <div className="wrap-login100">
          <input
            defaultValue="OXSUwkmJP_pxXGSmeVhxWabbp1aS3O4lGagerF_vW9OpupgjI5KyM0COTqR6w0i9ZlfLjR0VwjoZxZQWrz7WyIik2JOsgybNdW8iNn8W7SU1"
            name="__RequestVerificationToken"
            type="hidden"
          />
          <Header />
          <div className="bg-transparent" id="form-wrapper">
            <div className="white-bg parent-logo shadow">
              <span className="login100-form-avatar">
                <img src={require("../Assets/Images/uds.jpg")} alt="udslogo" />
                <label className="lblLogoTitle">
                  To reset your password please enter your email address or
                  supplier id number below and you will be emailed further
                  instructions
                </label>
              </span>
            </div>
            <div className="wrap-input100 validate-input m-t-85 m-b-35 remove-old">
              <label className="pd-25">Email or Supplier ID</label>
              <input
                className="input100 inputBg shadow"
                id="UserName"
                name="UserName"
                placeholder="Email or Supplier ID"
                type="text"
              />
              <span className="focus-input100" data-placeholder="Username" />
            </div>
            <span
              className="field-validation-valid text-danger"
              data-valmsg-replace="true"
            />
            <div className="container-login100-form-btn LoginButtonDiv">
              <button
                className="login100-form-btn"
                type="submit"
                value="Get Password"
              >
                <i className="icon fa fa-unlock-alt" />
                <span>Get Password</span>
              </button>
              <button
                className="login100-form-btn btnCancel"
                id="btnReturnToLogin"
                type="button"
                value="Return to Login"
                onClick={() => {
                  navigate("/");
                }}
              >
                <i className="icon fas fa-user" />
                <span>Return to Login</span>
              </button>
            </div>
            <HelpMessage />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
